import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './lib/firebase';
import './styles/globals.css';
import { registerWebMcpTools } from './lib/webmcp';
import { BookingProvider } from './components/booking';

// Expose read-only tools to any AI agent that supports WebMCP.
registerWebMcpTools();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <BookingProvider>
        <App />
      </BookingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
